/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/contact.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

import React from 'react';


/*----------------------------------
- APP
----------------------------------*/

import ContactLandingPage from '@/client/components/marketing/contact/ContactLandingPage';

/*----------------------------------
- ROUTE
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/contact', { ...({
    static: {
        refresh: '1h',
        urls: ['/contact'],
    },
}), ...{ filepath: "/app/client/pages/contact.tsx", sourceLocation: { line: 14, column: 1 }, id: "contact" } }, null, () => {
    return <ContactLandingPage />;
});
};
